import React, { useEffect, useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { useGetAllSitesQuery } from '../../services/api';
import Loading from '../../components/Loading';

const MapComponent = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    const { data: sitesData, isLoading, refetch  } = useGetAllSitesQuery();
    const activeSites = sitesData?.filter((site) => site.enabled) || [];
    // Ensure the latest data is fetched when component mounts
     useEffect(() => {
        refetch(); 
    }, [refetch]);

    const qatarCenter = { lat: 25.249469, lng: 51.472279 };

    const [hoveredMarker, setHoveredMarker] = useState(null);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

    const handleMouseMove = (event) => {
        const { clientX, clientY } = event;
        setMousePosition({ x: clientX, y: clientY });
    };

    return (
        <Box
            sx={{
                gridColumn: isSmallScreen ? 'span 12' : isTablet ? 'span 12' : 'span 4',
                gridRow: isSmallScreen ? 'span 3' : isTablet ? 'span 4' : 'span 4',
                backgroundColor: theme.palette.background.paper,
                borderRadius: '0.55rem',
                overflow: 'hidden',
                boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.1)',
                position: 'relative',
            }}
        >
            {isLoading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 1,
                    }}
                >
                    <Loading />
                </Box>
            )}

            <Box sx={{ height: '100%', width: '100%', position: 'relative' }} onMouseMove={handleMouseMove}>
                <APIProvider apiKey="AIzaSyAHJh02Ky1BfcvzBWPOew7ZLytA-1HY1Hc">
                    <Map style={{ width: '100%', height: '100%' }} defaultCenter={qatarCenter} defaultZoom={10} mapId="MAP_ID" gestureHandling="greedy" disableDefaultUI={true}>
                        {!isLoading &&
                            activeSites.map((site) => (
                                <Marker
                                    key={site._id}
                                    position={{
                                        lat: parseFloat(site.latitude),
                                        lng: parseFloat(site.longitude),
                                    }}
                                    title={site.name}
                                    icon={{
                                        url: site.connectedMACs?.some((device) => device.status === 'ONLINE')
                                            ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
                                            : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
                                    }}
                                    onMouseOver={() => setHoveredMarker(site)}
                                    onMouseOut={() => setHoveredMarker(null)}
                                />
                            ))}
                    </Map>
                </APIProvider>

                {hoveredMarker && (
                    <Box
                        sx={{
                            position: 'fixed',
                            top: mousePosition.y + 10,
                            left: mousePosition.x + 10,
                            backgroundColor: '#fff',
                            borderRadius: '4px',
                            padding: '8px',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                            zIndex: 2,
                            pointerEvents: 'none',
                        }}
                    >
                        <h3 style={{ margin: 0, fontSize: '14px', fontWeight: 'bold' }}>{hoveredMarker.name}</h3>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default MapComponent;
